import { render, staticRenderFns } from "./administration-menu.vue?vue&type=template&id=3bc6e90e"
import script from "./administration-menu.vue?vue&type=script&lang=js"
export * from "./administration-menu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports